import RootLayout from "./RootLayout";

export default RootLayout;
